module.exports = __webpack_public_path__ + "images/emoji/chestnut.3a5034816fa49247ecad.png";